import { render, staticRenderFns } from "./SocialNetworkComponent.vue?vue&type=template&id=eed100d0"
import script from "./SocialNetworkComponent.vue?vue&type=script&lang=js"
export * from "./SocialNetworkComponent.vue?vue&type=script&lang=js"
import style0 from "./SocialNetworkComponent.vue?vue&type=style&index=0&id=eed100d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports